import { MemoizedReactMarkdown } from "@/components/MemoizedReactMarkdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

import React from "react";

function TextView({ message }: { message: string }) {
  return (
    <div>
      <MemoizedReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw] as any}
        className="break-words"
        components={{
          a({ href, children, ...props }) {
            return (
              <a
                className="italic text-purple-500 underline"
                href={href}
                rel="noreferrer"
                target={"_blank"}
                {...props}
              >
                {children}
              </a>
            );
          },
        }}
      >
        {message}
      </MemoizedReactMarkdown>
    </div>
  );
}

export default TextView;
